var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab-layout", {
    attrs: {
      buttons: _vm.more.buttons,
      permissions: _vm.permissions,
      parameters: _vm.parameters
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _vm._v("\n        " + _vm._s(_vm.$l10n.__("Documents")) + "\n    ")
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "relative mt-3" },
                  [_c("preloader", { attrs: { display: _vm.isLoading } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "flex-column ov-reset" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "tab-document__description typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Retrouvez l'ensemble des documents liés à votre opportunité"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.mainDocument.length > 0
                      ? _c(
                          "div",
                          [
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "tab-document__subtitle typographies-heading-h3"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Document principal de votre opportunité"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table",
                              {
                                staticClass: "tab-document__table--main",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.mainDocument,
                                  stripe: "",
                                  fit: ""
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "ident",
                                    label: _vm.$t.__("common.labels.number"),
                                    width: 296
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tab-document__table-item"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "link semibold",
                                                    attrs: {
                                                      href: scope.row.link
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          scope.row.ident
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("CompassButton", {
                                                  staticClass:
                                                    "tab-document__table-show-panel",
                                                  attrs: {
                                                    label: _vm.$t.__(
                                                      "overview.tabs.TabDocuments.preview"
                                                    ),
                                                    type: "secondary",
                                                    size: "small",
                                                    leftIcon:
                                                      "panel-right-expand"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.displayPanel(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3725554848
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "object",
                                    label: _vm.$t.__(
                                      "overview.tabs.TabDocuments.object"
                                    )
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", {
                                              staticClass: "ellipsis",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.removeBreakline(
                                                    scope.row.subject
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3139621564
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "step",
                                    label: _vm.$t.__("common.labels.status"),
                                    width: "180"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("div", [
                                              _c("span", {
                                                staticClass: "chip",
                                                class: _vm.statusChip(
                                                  scope.row.step
                                                )
                                              }),
                                              _vm._v(
                                                _vm._s(scope.row.stepLabel) +
                                                  "\n                            "
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1888603704
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "date",
                                    label: "Date",
                                    width: "180"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "amountHT",
                                    label: _vm.$t.__(
                                      "common.labels.amount_excluding_tax"
                                    ),
                                    width: "180"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "amountTTC",
                                    label: _vm.$t.__(
                                      "common.labels.amount_including_tax"
                                    ),
                                    width: "220"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "h3",
                      {
                        staticClass:
                          "tab-document__subtitle typographies-heading-h3"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Autres documents de votre opportunité"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "CompassTabs",
                      {
                        staticClass: "tab-document__other",
                        model: {
                          value: _vm.activeTab,
                          callback: function($$v) {
                            _vm.activeTab = $$v
                          },
                          expression: "activeTab"
                        }
                      },
                      _vm._l(_vm.filterAvailableDoctypes(_vm.tabs), function(
                        tab,
                        tabIndex
                      ) {
                        return _c(
                          "CompassTabPane",
                          {
                            key: tabIndex,
                            attrs: {
                              label: tab.label,
                              name: tab.id,
                              badge: tab.items.length
                            }
                          },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "tab-document__table--others",
                                staticStyle: { width: "100%" },
                                attrs: { data: tab.items, stripe: "" }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "ident",
                                    label: _vm.$t.__("common.labels.number"),
                                    width: 296
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tab-document__table-item"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "link semibold",
                                                    attrs: {
                                                      href: scope.row.link
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          scope.row.ident
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("CompassButton", {
                                                  staticClass:
                                                    "tab-document__table-show-panel",
                                                  attrs: {
                                                    label: _vm.$t.__(
                                                      "overview.tabs.TabDocuments.preview"
                                                    ),
                                                    type: "secondary",
                                                    size: "small",
                                                    leftIcon:
                                                      "panel-right-expand"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.displayPanel(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "object",
                                    label: _vm.$t.__(
                                      "overview.tabs.TabDocuments.object"
                                    )
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", {
                                              staticClass: "ellipsis",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.removeBreakline(
                                                    scope.row.subject
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "step",
                                    label: _vm.$t.__("common.labels.status"),
                                    width: "180"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("div", [
                                              _c("span", {
                                                staticClass: "chip",
                                                class: _vm.statusChip(
                                                  scope.row.step
                                                )
                                              }),
                                              _vm._v(
                                                _vm._s(scope.row.stepLabel) +
                                                  "\n                                "
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "date",
                                    label: "Date",
                                    width: "180"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "amountHT",
                                    label: _vm.$t.__(
                                      "common.labels.amount_excluding_tax"
                                    ),
                                    width: "180"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "amountTTC",
                                    label: _vm.$t.__(
                                      "common.labels.amount_including_tax"
                                    ),
                                    width: "180"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    fixed: "right",
                                    label: "",
                                    width: "40"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-dropdown",
                                              {
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "dropdown",
                                                      fn: function() {
                                                        return [
                                                          _c(
                                                            "el-dropdown-menu",
                                                            [
                                                              !scope.row.isMain
                                                                ? _c(
                                                                    "el-dropdown-item",
                                                                    {
                                                                      staticClass:
                                                                        "gray-100",
                                                                      nativeOn: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.defineMainDocument(
                                                                            scope
                                                                              .row
                                                                              .linkid
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                " +
                                                                          _vm._s(
                                                                            _vm.$l10n.__(
                                                                              "Définir en tant que document principal"
                                                                            )
                                                                          ) +
                                                                          "\n                                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  staticClass:
                                                                    "gray-100",
                                                                  nativeOn: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.unlinkDocument(
                                                                        scope
                                                                          .row
                                                                          .linkid
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                " +
                                                                      _vm._s(
                                                                        _vm.$l10n.__(
                                                                          "Délier le document"
                                                                        )
                                                                      ) +
                                                                      "\n                                            "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      href: "javascript:;"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "icon-burger"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "placeholder",
        fn: function() {
          return [
            _c("div", { staticClass: "well" }, [
              _vm._v("\n            " + _vm._s(_vm.placeholder) + "\n        ")
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }